import { render, staticRenderFns } from "./CreateNewYearDialog.vue?vue&type=template&id=bd3be280&scoped=true"
import script from "./CreateNewYearDialog.vue?vue&type=script&lang=js"
export * from "./CreateNewYearDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3be280",
  null
  
)

export default component.exports